let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ty2Sw")).then(() => parcelRequire('40Ydl'));